import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Notification } from 'src/app/models/notification.model';

type NotificationActionsType = 'pinned' | 'active' | 'postponed' | 'other';

@Component({
    selector: 'app-notification-actions-buttons',
    templateUrl: './notification-actions-buttons.component.html',
    styleUrls: ['./notification-actions-buttons.component.scss'],
})
export class NotificationActionsButtonsComponent {
    @Input() notification!: Notification;
    @Input() type: NotificationActionsType = 'active';

    @Output() createTask = new EventEmitter<{ notification: Notification; event: Event }>();
    @Output() markAsRead = new EventEmitter<{ notification: Notification; event: Event }>();
    @Output() markAsUnread = new EventEmitter<{ notification: Notification; event: Event }>();
    @Output() togglePin = new EventEmitter<{ notification: Notification; event: Event }>();
    @Output() postpone = new EventEmitter<{ notification: Notification; days: number }>();
    @Output() cancelPostpone = new EventEmitter<{ notification: Notification; event: Event }>();

    showPostponeMenu = false;

    onCreateTask(event: Event): void {
        event.stopPropagation();
        event.preventDefault();
        this.createTask.emit({ notification: this.notification, event });
    }

    onMarkAsRead(event: Event): void {
        event.stopPropagation();
        event.preventDefault();
        this.markAsRead.emit({ notification: this.notification, event });
    }

    onMarkAsUnread(event: Event): void {
        event.stopPropagation();
        event.preventDefault();
        this.markAsUnread.emit({ notification: this.notification, event });
    }

    onTogglePin(event: Event): void {
        event.stopPropagation();
        event.preventDefault();
        this.togglePin.emit({ notification: this.notification, event });
    }

    onPostponeClick(event: Event): void {
        event.stopPropagation();
        event.preventDefault();
        this.showPostponeMenu = !this.showPostponeMenu;
    }

    onPostpone(days: number): void {
        this.postpone.emit({ notification: this.notification, days });
        this.showPostponeMenu = false;
    }

    onCancelPostpone(event: Event): void {
        event.stopPropagation();
        event.preventDefault();
        this.cancelPostpone.emit({ notification: this.notification, event });
    }

    get showCreateButton(): boolean {
        return true;
    }

    get showMarkReadButton(): boolean {
        return !this.notification.isRead;
    }

    get showMarkUnreadButton(): boolean {
        return this.notification.isRead;
    }

    get showPinButton(): boolean {
        return this.type !== 'postponed';
    }

    get showPostponeButton(): boolean {
        return (this.type === 'active' || this.type === 'other') && !this.notification.isRead;
    }

    get isPinned(): boolean {
        return this.notification.isPinned;
    }
}
